export const APPLIED_TO_SERVICE_CENTER_OPTIONS = [
  { value: null, label: 'claim.accInfo.no' },
  { value: 'beforeSeeingDoctor', label: 'claim.accInfo.beforeSeeingDoctor' },
  { value: 'afterSeeingDoctor', label: 'claim.accInfo.afterSeeingDoctor' },
];

export const ACCIDENT_INFO_FIELDS = [
  'accidentDate',
  'beforeSeeingDoctor',
  'afterSeeingDoctor',
  'contract',
  'damageAmount',
  'currency',
  'accidentInformation',
  'isAppliedToServiceCenter',
  'accCountry',
  'isAccInArmenia',
  'accState',
  'accVillage',
  'accStreet',
  'formLanguage',
];
